<template>
    <div class="absolute inset-0 z-10 flex items-center justify-center animate-pulse bg-white/10">
        <span class="text-xs font-bold">
            {{ lang('content::content.blocks.loading_preview') }}
        </span>
    </div>
</template>
